import CaptionWithBorders1 from "../../../../components/ChapterImage/Image";
import { generateTableOrderedList, paraStyle, pointStyle, sectionStyle, tableCellStyle } from "../ChapterList";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { ImageDesc53, ImageDesc54, ImageDesc55, ImageDesc56 } from "../../../../utils/tmp/ImageDescription/VwdcID";

const borderColor = "#AAAAAA";
const specialBorderColor = "#F3F3F4";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#CCE5E5",
    verticalAlign: "baseline",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#F45B69',
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: '16px',
    border: `1px solid ${borderColor}`,
    verticalAlign: 'baseline',
  },
  [`&.${tableCellClasses.body}`]: {
    fontfamily: "Lato",
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "27px",
    color: "rgb(85, 85, 85)",
    border: `1px solid ${borderColor}`,
    verticalAlign: 'baseline',
  },
  "&:first-child": {
    borderLeft: `1px solid ${specialBorderColor}`,
  },
  "&:last-child": {
    borderRight: `1px solid ${specialBorderColor}`,
  },
}))

const tableHeading = {
  color: "#000",
  fontSize: "1rem",
  fontWeight: 600,
  paddingRight: "5px",
};

const generateTableUnOrderedList = (stringsArray) => {
  return (
    <p id="typgraphyList">
      {stringsArray?.map((text, index) => (
        <p style={{ ...tableCellStyle, paddingLeft: "15px" }}>{text}</p>
      ))}
    </p>
  );
};

const relevantdetails1 = [
  <><span style={sectionStyle}>g.</span> Comfort Items – Comfort items mean any article of choice of the vulnerable witness which may have a calming effect at the time of deposition and may include stuffed toy, blanket or book.</>,
  <><span style={sectionStyle}>k.</span> Testimonial Aids – means and includes screens; single visibility mirrors, curtains, live links, image and/or voice altering devices; or any other technical devices, facilities and equipment.</>,
  <><span style={sectionStyle}>n.</span> Waiting Area- A safe space for vulnerable witnesses where they can wait.</>,
]

const considerations1 = [
  "The waiting area must be equipped with comfort items such as stuffed toys, books or blankets, to ensure that the vulnerable witness is comfortable within it.",
  "The VWDC Courtroom must have testimonial aids such as screens, single visibility mirrors, curtains, live links, image and/or voice altering devices, which may be used by the witnesses if necessary.",
  "All precautions must be taken to ensure that the vulnerable witness is safe within the waiting area.",
]

const relevantdetails3 = [
  "The Courts shall ensure that a waiting area for vulnerable witnesses with the support person, and the lawyer of the vulnerable witness, if any, is separate from waiting areas used by other persons. Care shall be taken to ensure that the waiting room is used only by the vulnerable witness and the non-offending family members and support persons.",
  "The waiting area should be accessible to all vulnerable witnesses, including those with disability.",
  "The waiting area for vulnerable witnesses should be furnished so as to make a vulnerable witness comfortable.",
  "This may include, but not be limited to, being furnished and equipped with toys, books, games, drawing and painting materials and other such activities, TV, etc., which can help lower the anxiety of the witness.",
  "It could include a place for very young child witnesses to rest or sleep.",
  "Accessible toilets and drinking water facilities should also be available inside the waiting room or within close proximity.",
  "The approach to the waiting area shall be in such a way that allows the witness to access it with ease and without having to confront other litigants, police, or the accused and their associates.",
  "The waiting area needs to be equipped with a digital “Case Number Display Monitor” that shows the case being called in the Court.",
  "Arrangements for the vulnerable witness to depose from the waiting area, which may include monitors and screens for recording of the evidence of the child shall be made available.",
]

const considerations3 = [
  "The VWDC must have a separate and segregated waiting area for witnesses. The waiting area must be used only by the witness and their non-offending members or support persons.",
  "The waiting area must be accessible to all vulnerable witnesses including Persons with Disabilities.",
  "The waiting area must be furnished such that it makes the vulnerable witnesses feel comfortable.",
  "The waiting area must be equipped with toys, books, games, drawing materials, paintings, TV, etc., which may be helpful to reduce anxiety of witnesses such as children.",
  "The waiting area must have space for child witnesses to sleep or rest.",
  "Accessible, gender-neutral and inclusive washrooms and drinking water facilities must be provided within the Complex or in close proximity to it.",
  "Segregated paths and adequate security  provisons must be provided to prevent confrontation between the Vulnerable Witness and other litigants, police, Accused Persons or their associates.",
  "The waiting area must have a digital 'Case Number Display Monitor' that shows the case being called in Court.",
  "The waiting area must have digital equipment such as monitors and screens that can be used by the vulnerable witnesses to depose from the waiting area itself.",
]

const relevantdetails4 = [
  <><span style={sectionStyle}>ii.</span> Separate and safe waiting areas and passage thereto should be provided for vulnerable witnesses.</>,
  <><span style={sectionStyle}>iii.</span> Care shall be taken to ensure that the vulnerable witness Courtroom is accessible to Persons with Disabilities.</>,
  <><span style={sectionStyle}>iv.</span> The vulnerable witness may be allowed to testify from a place other than the witness chair. The witness chair or other place from which the vulnerable witness testifies may be turned to facilitate their testimony but the accused or the opposite party and their counsel must have a frontal or profile view of the vulnerable witness even by a video link, during the testimony of the vulnerable witness. The witness chair or other place from which the vulnerable witness testifies may also be rearranged to allow the vulnerable witness to see the accused or the opposite party and their counsel, if the vulnerable witness chooses to look at them, without turning their body or leaving the witness stand.</>,
  <><span style={sectionStyle}>vii.</span> Access to crèche facilities within the Court premises should be enabled for vulnerable witnesses who may require child care facilities on the date of their deposition.</>,
]

const considerations4 = [
  "The Court has a duty to provide safe and separate waiting areas and passages to vulnerable witnesses.",
  "The Court has a duty to ensure that the VWDC is accessible to all vulnerable witnesses including Persons with Disabilities.",
  "The Court has a duty to allow the vulnerable witness to depose from a place other than the witness chair to ensure comfort. However, the Court must also ensure that the accused or the opposite party and their counsel have a frontal or profile view of the vulnerable witness even by a video link, during the testimony.",
  "The witness chair or other place from which the vulnerable witness testifies may also be rearranged to allow the vulnerable witness if they so desire.",
  "The Court has a duty to provide crèche facilities to vulnerable witnesses who may require child care facilities.",
]

const relevantdetails5 = [
  <><span style={sectionStyle}>iv.</span> Additional measures may be taken to enable the recording of evidence of vulnerable witnesses with disability.</>,
  "For instance, steps can be taken to record witness testimony in compliance with Section 278, Cr.PC in Braille to ensure a vulnerable witness is not dependant on another person to read their testimony out",
  "use of amplification devices/ document magnifiers/ ensuring that all notices that require a response or an action to be taken (e.g. summons, orders) are available by accessible means and in accessible formats",
  "use of video and audio guides; ",
  "engagement of sign language interpreters;",
  "enabling wheelchair access in the Court premises, Courtroom and witness box. ",
  "Adequate time should be given to vulnerable witnesses using communication boards during evidence.",
]

const considerations5 = [
  "Provisions must be made to enable the recording of evidence of vulnerable witnesses with disabilities which includes the recording of evidence in Braille to ensure the independence of vulnerable witnesses.",
  "Provisions must be made for the use of amplification devices / document magnifiers / ensuring that all notices that require a response or an action to be taken are available in all formats.",
  "Use of video and audio guides must be facilitated.",
  "There must be provision for seating and other amenities for sign language interpreters in the Court for better accessibility.",
  "There must be provisions for wheelchair access within the Court premises, including pathways that are amenable for manoeuvring the wheelchair around.",
]

const relevantdetails10 = [
  "It shall be the duty of the guardian ad litem of the vulnerable child witness so appointed by Court to:",
  "a. attend all depositions, hearings, and trial proceedings in which a vulnerable witness participates.",
  "d. Assist the vulnerable witness and their family in coping with the emotional effects of participating in any case/proceedings, especially the crime and subsequent criminal or non-criminal proceedings in which the vulnerable witness is involved;",
]

const considerations10 = [
  "There must be seating provisions within the Courtroom for the guardian of the vulnerable witness.",
  "There must be seating provisions within the deposition centre waiting room and the video linkage room for the guardian accompanying the vulnerable witness.",
]

const relevantdetails11 = [
  <><span style={sectionStyle}>e.</span> avoiding exposure to the accused by using screens or single visibility mirror;</>,
  <><span style={sectionStyle}>h.</span> if the child victim or witness refuses to give testimony in the presence of the accused or if circumstances show that the child may be inhibited from speaking freely in that person’s presence, the Court shall give orders to temporarily remove the accused from the Courtroom to an adjacent room with a video link or a one way mirror visibility into the Courtroom. In such cases, the defense lawyer shall remain in the Courtroom and question the vulnerable witness , and the accused’s right of confrontation shall thus be guaranteed;</>,
]

const considerations11 = [
  "There must be a one-way mirror in the Courtroom for the accused dock or room.",
  "There must be a temporary room adjacent to the Courtroom or a tinted accused room/dock within the Courtroom.",
]

const outDoorSetting = [
  "An outdoor area including a variety of natural elements like grassy patches, trees providing shade, and flowerbeds with colourful blooms must be provided adjacent to the space.",
  "It must also be provided with a play structure made of wood or natural materials, integrating elements of climbing, exploration, and imaginative play.",
  "Sensory gardens with different textures, scents, and plants must be incorporated in the design to ensure that the children can touch, smell, and observe.",
  "Safe and soft ground coverings such as rubber mulch or grass must be provided to ensure a comfortable and secure play surface.",
]

const designConsideration2 = [

  "Colour in elements that are easy to change or adapt must be used, such as decor items, cushions, or removable wall art, allowing flexibility in adjusting the colour scheme if needed.",
]

const softClamingArray = [
  <><i>Pastel Shades:</i> Soft pastel colours like light blues, muted greens, pale yellows, or gentle pinks can create a soothing and welcoming atmosphere in child-friendly spaces.</>,
  <><i>Neutral Tones:</i> Consider incorporating neutral tones such as soft greys, beige, or warm taupes as a base colour to balance brighter hues and provide a calming backdrop.</>,
  <><i>Nature-Inspired Colours:</i> Colours inspired by nature, like soft earthy tones (e.g., light browns, muted greens), can evoke a sense of tranquillity and connection to the natural world.</>,
  <><i>Balanced Colour Palettes:</i> Balanced colour palettes combining softer shades with pops of colour sparingly add to the visual interest without creating an overstimulating environment.</>,
]

const avoidingArray = [
  <><i>Limiting High-Contrast Schemes:</i> Highly contrasting or overly bright colour combinations may be overwhelming, especially for children with sensory sensitivities and trauma.</>
]

const designConsideration3 = [
  <><i>Plush Fabrics:</i> Soft and fluffy rugs, cushions, or bean bags made from plush materials like fleece or faux fur must be used. These textures offer a comforting and tactile experience for children. </>,
]

const softTextureArray = [
  <><i>Wooden Elements:</i> Wooden furniture or toys with smooth, natural finishes must be incorporated. Wooden surfaces provide a warm and tactile feel while connecting to nature.</>,

  <><i>Natural Fibres:</i> Materials like rattan, wicker, or bamboo for furniture pieces or decorative elements must be used. These natural fibres add texture and visual interest while offering an organic feel.</>,
]

const designConsideration4 = [
  "To ensure a child-friendly space, large windows must be provided that allow ample natural light to enter during the day. Natural light creates a bright and inviting atmosphere, positively impacting mood and well-being.",
]

const adjustableLights = [
  "Soft and diffused lighting fixtures, such as pendant lamps with fabric shades or recessed lights with dimmer switches must be used to provide adjustable brightness levels. Dimmable lights offer flexibility in creating a calming ambience, especially during relaxation times.",
  "Sensory lights may be provided to cater to the needs of users with autism. "
]

const designConsideration5 = [
  "The partition must be designed to perform minimum STC 55 and door to perform STC 45.",
  "The space must be strategically placed away from the common areas to avoid disturbances in case of open design.",
  "Acoustic screens or plantations can be provided to achieve isolation in open spaces.",
]

const absorptionArray = [
  "The space must also be treated with acoustic materials to avoid sound reflection and noise buildup, acoustic ceiling materials, wall panels and or curtains can be used to achieve sufficient absorption.",
  "The ceiling must be treated with acoustic materials to avoid sound reflection. A minimum of 0.75 NRC materials must be provided.",
  "Soft furniture may be utilised to achieve sound absorption.",
]

const designConsideration6 = [
  "Plush sofas, bean bags, armchairs, or seating options with  soft material, and ergonomic designs must be used.",
]

const furnishingArray = [
  "Display boards, a range of age-appropriate and culturally significant books, games, etc., may be provided to address children of all ages.",
  "A selection of toys such as fidget spinners, etc., must be provided to aid children with variations of autism, ADHD, etc., The toys provided must not be competitive in nature. ",
  "Additional items may be placed in the room to make it soothing or calming for all such as plants, sensory  sensory boards, or textured panels.",
]

const furnitureArray = [
  "Contextual furnishing, taking into consideration local cultural elements must be provided to create familiarity. ",
  "Design furnishings specifically for diverse user groups, featuring rounded edges, playful colours, and designs that stimulate imagination and creativity must be provided.",
]

const designConsideration7 = [
  "Provisions must be made to help the children to  engage and participate actively. ",
  "Age-appropriate activities, toys, or interactive elements must be provided that engage children without causing disruptions.",
  "Quiet spaces for relaxation or focus must be provided, particularly for those sensitive to sensory stimuli.",
]

const designConsideration8 = [
  "The space must be designed to ensure that children can navigate the space with little to none management or supervision. ",
  "The objects in the room, as well as counters, seating provisions, washbasins, faucets, mirrors, etc., must be placed at child-friendly heights. ",
  "Child-friendly signages must be provided.",
]

const designConsideration9 = [
  "Clear wayfinding and spatial arrangement must be provided. ",
  "Door Frame metal detectors can be seamlessly integrated with the area interiors for security elements blended with room furniture, ensuring that they do not look intimidating to the users."
]

const designConsideration10 = [
  "Baby-changing stations and child protection seats must be provided in all washrooms, lactation rooms, etc. ",
  "Wide kerb ramps, avoiding cobbled surfaces along walkable pathways, etc., must be provided to ensure easy navigation for baby prams. ",
]

export const TableHeader7 = () => {
  return (
    <TableHead>
      <TableRow>
        <StyledTableCell>
          Section No.
        </StyledTableCell>
        <StyledTableCell>
          Section Title
        </StyledTableCell>
        <StyledTableCell>
          Section Relevant Details
        </StyledTableCell>
        <StyledTableCell>
          Design Considerations
        </StyledTableCell>
      </TableRow>
    </TableHead>
  );
};

export const TableHeader = () => {
  return (
    <TableHead>
      <TableRow>
        <StyledTableCell>
          Design Strategy
        </StyledTableCell>
        <StyledTableCell>
          Design Consideration
        </StyledTableCell>
      </TableRow>
    </TableHead>
  );
};

export const Table7 = () => {
  return (
    <TableContainer>
      <Table aria-label="customized table">
        <TableHeader7 />
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>S.3.</StyledTableCell>
            <StyledTableCell>Definitions</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(relevantdetails1)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(considerations1)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.13.</StyledTableCell>
            <StyledTableCell>Assistance of an interpreter, translator, special educator or expert</StyledTableCell>
            <StyledTableCell>
              <span style={sectionStyle}>(ii)</span> Wherever necessary, the Court may, suo moto or upon an application presented by either party or a Support Person of vulnerable witnesses take the assistance of a qualified and experienced interpreter, translator, special educator or expert, to enable recording of evidence of vulnerable witnesses, and on payment of such fees as may be prescribed by the State Government or authority concerned.
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["Provision must be made for seating and other amenities for an interpreter, translator, special educator or expert, to enable recording of evidence of vulnerable witnesses."])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.17.</StyledTableCell>
            <StyledTableCell>Waiting Area for Vulnerable Witness</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(relevantdetails3)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(considerations3)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.18.</StyledTableCell>
            <StyledTableCell>Duty to provide comfortable environment</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(relevantdetails4)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(considerations4)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.19.</StyledTableCell>
            <StyledTableCell>Directions for Judges of Criminal Courts, Children’s Courts and Juvenile Justice Boards</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(relevantdetails5)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(considerations5)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.21.</StyledTableCell>
            <StyledTableCell>Live-link television testimony in criminal cases where the vulnerable witness is involved</StyledTableCell>
            <StyledTableCell><span style={sectionStyle}>i.</span> Any party in the case, the prosecutor, counsel or the guardian ad litem may apply for an order that the testimony of the vulnerable witness be taken in a room outside the Courtroom and be televised to the Courtroom by live-link television.</StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["A live link television/video linkage room must be provided for recording the testimony of the witness outside the Courtroom."])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.22.</StyledTableCell>
            <StyledTableCell>Provision of testimonial aids to prevent exposure of vulnerable witness to the accused</StyledTableCell>
            <StyledTableCell>The Court may suo moto or on an application made even by the vulnerable witness, prosecutor or counsel or the guardian ad litem order testimonial aid such as screens, one-way mirror, curtains or other devices to be placed in the Courtroom in such a manner that the vulnerable witness cannot see the accused/opposite party while testifying and at the same time ensuring that the opposite party/accused is in a position to hear the statement of the vulnerable witness and communicate with their advocate.</StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["There must be testimonial aids such as screens, one-way mirror, curtains or other devices to be placed in the Courtroom in such a manner that the vulnerable witness cannot see the accused/opposite party while testifying."])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.23.</StyledTableCell>
            <StyledTableCell>Factors to be considered while considering the application under Guidelines</StyledTableCell>
            <StyledTableCell>
              <span style={sectionStyle}>iii.</span> The Court shall ensure ahead of time that the equipment is working, recordings can be played and that camera angles will not permit the witness to see the defendant. The Court shall not wait until the victim or vulnerable witness is in the live link room to run checks: delays and malfunctions can be disruptive to the vulnerable witness. Where a live link is being used during the vulnerable witness’s testimony, ensure that they are able to see all of the questioner’s face. It should be explained that the judge or magistrates can always see the vulnerable witness over the live video link even when the witness cannot see the judge or magistrates.
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["The cameras must be placed in a manner in order to ensure that the witness does not see the defendant and the judges are always able to see the vulnerable witness."])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.31.</StyledTableCell>
            <StyledTableCell>Protective measures</StyledTableCell>
            <StyledTableCell><span style={sectionStyle}>a.</span> prohibiting direct or indirect contact between a vulnerable witness and the accused/opposite party at any point in the justice process.</StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["Security/safety measures such as CCTV cameras, security personnel or segregated pathways must be available within the Court premises."])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.35.</StyledTableCell>
            <StyledTableCell>Duties of guardian ad litem</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(relevantdetails10)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(considerations10)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.37.</StyledTableCell>
            <StyledTableCell>Measures to protect the privacy and well-being of child victims and witnesses</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(relevantdetails11)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(considerations11)}</StyledTableCell>
          </StyledTableRow>

        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const Table8 = ({
  img1,
  img2,
  img3,
  img4,
}) => {

  const designConsideration1 = [
    <>All spaces used by vulnerable users (including child-care spaces) must be designed to bring nature indoors to enhance the sensory experience, and help to reduce stimulation for children with hypersensitive variation of autism, ADHD, etc.</>,
    "The space must be provided with large windows to allow ample natural light to filter in, creating a bright and airy environment.",
    "Introduce plants, natural materials (like wood, stone, or water features), sounds of nature, etc., must be introduced. ",
  ]

  const variedTactile = [
    <><i>Tactile Walls:</i> Interactive walls with textured elements like bead mazes, sensory boards, or textured panels must be created at varying heights to engage children's senses and encourage exploration.</>,
    <><i>Textured Flooring:</i> Textured flooring materials such as rubberized mats with different patterns or textures must be used to ensure that the children can walk or play on, providing sensory feedback.</>
  ]

  return (
    <TableContainer>
      <Table aria-label="customized table">
        <TableHeader />
        <TableBody>
          <StyledTableRow>
            <StyledTableCell style={{ width: "25%", paddingTop: "15px", fontWeight: "600", color: "black" }}>
              Nature Integration
              <CaptionWithBorders1
                image={[img1]}
                caption="Image 53: Examples of child-care centres using nature integration principles"
                creditLabel="Source"
                imageCredit="KFF Health News"
                height={"300px"}
                imageDescription={ImageDesc53}
              />
            </StyledTableCell>
            <StyledTableCell style={tableHeading}>
              <b>Indoor Setting:</b>{generateTableUnOrderedList(designConsideration1)}
              <b>Outdoor Setting:</b>{generateTableUnOrderedList(outDoorSetting)}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ paddingTop: "15px", fontWeight: "600", color: "black" }}>
              Colour
              <CaptionWithBorders1
                image={[img2]}
                caption="Image 54: Example of positive usage of colours"
                creditLabel="Source"
                imageCredit="Indoor Environments for Young Children"
                height={"300px"}
                imageDescription={ImageDesc54}
              />
            </StyledTableCell>
            <StyledTableCell style={tableHeading}>
              <b>Tactile Colour Use:</b>
              {generateTableUnOrderedList(designConsideration2)}
              <b>Soft and Calming Colours:</b>
              <p style={tableCellStyle}>
                A positive usage of colours (examples: blues, greens, and off-whites) must be adopted in the space to define the space and optimise colour preference.
              </p>
              {generateTableUnOrderedList(softClamingArray)}
              <b>Avoiding Overwhelming Colours:</b>
              <p style={tableCellStyle}>
                A negative usage of overwhelming colours (dark colours, or too many colours) which may lead to confusion and over-stimulation, particularly for children with hypersensitive variation of autism, ADHD, etc., must be avoided.
              </p>
              {generateTableUnOrderedList(avoidingArray)}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ paddingTop: "15px", fontWeight: "600", color: "black" }}>
              Textures
              <CaptionWithBorders1
                image={[img3]}
                caption="Image 55: Example of learning wall panel for sensory rooms"
                creditLabel="Source"
                imageCredit="Weeping Water Elementary School, Nebraska, US"
                imageDescription={ImageDesc55}
              />
            </StyledTableCell>
            <StyledTableCell style={tableHeading}>

              <b>Soft Textures:</b>
              {generateTableUnOrderedList(designConsideration3)}

              <b>Natural Textures:</b>
              {generateTableUnOrderedList(softTextureArray)}

              <b>Varied Tactile Experiences:</b>
              {generateTableUnOrderedList(variedTactile)}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ paddingTop: "15px", fontWeight: "600", color: "black" }}>Lighting</StyledTableCell>
            <StyledTableCell style={tableHeading}>
              <b>Natural Lighting:</b>
              {generateTableUnOrderedList(designConsideration4)}

              <b>Soft and Adjustable Lights:</b>
              {generateTableUnOrderedList(adjustableLights)}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ paddingTop: "15px", fontWeight: "600", color: "black" }}>Acoustics</StyledTableCell>
            <StyledTableCell style={tableHeading}>
              <b>Isolation:</b>
              {generateTableUnOrderedList(designConsideration5)}

              <b>Absorption:</b>
              {generateTableUnOrderedList(absorptionArray)}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ paddingTop: "15px", fontWeight: "600", color: "black" }}>Furnishing</StyledTableCell>
            <StyledTableCell style={tableHeading}>
              <b>Ergonomic, Soft and Comfortable Seating:</b>
              {generateTableUnOrderedList(designConsideration6)}

              <b>Activity-Based and Sensory Furnishings:</b>
              {generateTableUnOrderedList(furnishingArray)}

              <b>Adaptive and Inclusive Furniture:</b>
              {generateTableUnOrderedList(furnitureArray)}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ fontWeight: "600", color: "black" }}>Engagement and Distraction</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(designConsideration7)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ fontWeight: "600", color: "black" }}>Accessibility</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(designConsideration8)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ fontWeight: "600", color: "black" }}>Non-confrontational Design and Passive Security Strategy</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(designConsideration9)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ fontWeight: "600", color: "black" }}>
              Other infrastructural support
              <CaptionWithBorders1
                image={[img4]}
                caption="Image 56: Example of child protection seats"
                creditLabel="Image Credit"
                imageCredit="369 Ochre Studio"
                imageDescription={ImageDesc56}
              />
            </StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(designConsideration10)}</StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};